import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {catchError} from 'rxjs/operators';
import {DoctorDataModel} from '../../../models/doctors/doctor-data.model';
import {ReferralInfoObjModel} from './models/referral-info-obj.model';
import {
    DataReferralDoctorsModel, emailReferralPortalInformationModel,
    ReferralDataModel,
    ReferralOtherServicesDataModel, ReferralScheduleDataModel,
    ReferralTreatmentsDataModel, TDOReferringDataDoctorModel
} from './models/referral-data.model';
import {ContactDataModel} from '../../../models/person/contact-data.model';
import {ReferringDoctorDataModel} from './models/referring-doctor-data.model';
import {EnumValidValueModel} from '../../../models/enum/enum-valid-value.model';

import {PatientSearchModel} from '../../../models/patient/patient-search.model';
import {environment} from '../../../../environments/environment';
import {
    ReferralPortalAuthenticateResponseModel
} from '../../referral-manager/referral-portal/Models/referralPortalAuthenticateResponse.model';
import {
    ReferringDoctorQueryOptionsModel
} from '../../../models/doctors/doctor-query-options.model';
import {SystemTaskDataModel} from '../../../models/messaging/system-task-data.model';
import {emailInformationModel, ReferralEntityModel} from './models/referral-Entity.model';
import {ReferralFilterModel} from "./models/referral-filter.model";


@Injectable({
    providedIn: 'root'
})
export class ReferralsService {

    public api = '';


    constructor(
        private http: HttpClient,
    ) {
    }

    // tslint:disable-next-line:typedef
    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any) => {
            console.error(error);
            return of(result);
        };
    }

    getDoctorContacts(doctorId: string): Observable<ContactDataModel[]> {
        return this.http.get<ContactDataModel[]>(this.api + `api/refer/get-doctor-contacts/${doctorId}`);
    }

    getSelectedDoctor(guid: string): Observable<DoctorDataModel> {
        return this.http.get<DoctorDataModel>(this.api + `api/refer/doctor/${guid}`)
            .pipe(catchError(this.handleError<any>('GetdataDoctors4ReferDr')));
    }

    getAllReferrals(): Observable<any[]> {
        return this.http.get<any[]>(this.api + 'api/referral/get-all-referrals');
    }

    getReferralInfoByRefID(referralId: string): Observable<ReferralInfoObjModel> {
        return this.http.get<ReferralInfoObjModel>(this.api + `api/referral/get-referral-info/${referralId}`);
    }

    getReferralsByRefDoc(RefDoctorID: string): Observable<ReferralDataModel[]> {
        return this.http.get<ReferralDataModel[]>(this.api + `api/referral/get-all-referrals/${RefDoctorID}`);
    }

    getValidValueByName(validValueName: string): Observable<EnumValidValueModel> {
        return this.http.get<any>(this.api + `api/valid-values/${validValueName}`);
    }

    getProcedures(ProviderID: string): Observable<any[]> {
        return this.http.get<any[]>(this.api + `api/referral/get-procedures/${ProviderID}`);
    }

    getTreatments(ProviderID: string): Observable<any[]> {
        return this.http.get<any[]>(this.api + `api/referral/get-treatments/${ProviderID}`);
    }

    saveReferral(token: string, TDOGUID: string, newSave: ReferralDataModel): Observable<ReferralDataModel> {
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token);
        return this.http.post<ReferralDataModel>(this.api + `api/referral/save-referral/${TDOGUID}`, newSave, {headers})
            .pipe(catchError(this.handleError<any>('save-referral')));
    }

    sendReferralPortalEmail(token: string, TDOGUID: string,  emailInformation: emailReferralPortalInformationModel) {
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token);
        return this.http.post<emailReferralPortalInformationModel>(this.api + `api/referral/send-referral-portal-email/${TDOGUID}`, emailInformation, {headers})
            .pipe(catchError(this.handleError<any>('send-referral-portal-email')));
    }

    saveReferralPortalTask(token: string, TDOGUID: string, task: SystemTaskDataModel) {
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token);
        return this.http.post<SystemTaskDataModel>(`api/referral-task/save-task/${TDOGUID}`, task, {headers})
            .pipe(catchError(this.handleError<any>('save-task')));
    }

    uploadReferralPortalDocuments(token: string, TDOGUID: string, formData: FormData) {
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token);
        return this.http.post<any>(`api/referral-Portal/save-referral-files/${TDOGUID}`, formData, {headers})
            .pipe(catchError(this.handleError<any>('save-referral-files')));
    }

    getReferralDocs(): Observable<ReferringDoctorDataModel[]> {
        return this.http.get<ReferringDoctorDataModel[]>(this.api + 'api/referral/get-referring-doctors');
    }

    getReferralDoc(referringDoctorID: string): Observable<ReferringDoctorDataModel> {
        return this.http.get<ReferringDoctorDataModel>(this.api + `api/referral/get-referring-doctor/${referringDoctorID}`);
    }

    getReferralDocsByProvider(providerDoctorID: string): Observable<ReferringDoctorDataModel[]> {
        return this.http.get<ReferringDoctorDataModel[]>(this.api + `api/referral/get-referring-doctors-by-provider/${providerDoctorID}`);
    }

    saveReferralDoc(token: string, TDOGUID: string, newSave: ReferringDoctorDataModel): Observable<ReferringDoctorDataModel> {
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token);
        return this.http.post<ReferringDoctorDataModel>(this.api + `api/referral/save-referral-doctor/${TDOGUID}`, newSave, {headers});
    }

    saveReferralSchedule(newSave: ReferralScheduleDataModel): Observable<ReferralScheduleDataModel> {
        return this.http.post<ReferralScheduleDataModel>(this.api + 'api/referral/save-referral-schedule', newSave);
    }

    saveReferralService(newSave: ReferralOtherServicesDataModel): Observable<ReferralOtherServicesDataModel> {
        return this.http.post<ReferralOtherServicesDataModel>(this.api + 'api/referral/save-referral-service', newSave);
    }

    saveReferralTreatment(newSave: ReferralTreatmentsDataModel): Observable<ReferralTreatmentsDataModel> {
        return this.http.post<ReferralTreatmentsDataModel>(this.api + 'api/referral/save-referral-treatment', newSave);
    }

    saveReferralEntity(referralEntity: ReferralEntityModel): Observable<ReferralEntityModel> {
        return this.http.post<ReferralEntityModel>(this.api + 'api/referral/saveReferralEntity', referralEntity);
    }

    generateToken(referralEntity: ReferralEntityModel, enterpriseId: string): Observable<ReferralEntityModel> {
        return this.http.post<ReferralEntityModel>(this.api + `api/referral-portal-site/generatereferralportaljwttoken/${enterpriseId}`, referralEntity);
    }


    sendReferralEntityEmail(emailInformation: emailInformationModel) {
        return this.http.post<boolean>('api/referral/sendReferralEntityEmail', emailInformation);
    }

    saveEditedReferralDoc(save: ReferringDoctorDataModel): Observable<ReferringDoctorDataModel> {
        return this.http.post<ReferringDoctorDataModel>(this.api + 'api/referral/save-edited-referral-doctor', save);
    }

    getSchedule(ProviderID: string): Observable<any[]> {
        return this.http.get<ReferralScheduleDataModel[]>(this.api + `api/referral/get-schedule/${ProviderID}`);
    }

    getDisconfort(): Observable<any[]> {
        return this.http.get<any[]>(this.api + 'api/referral/get-disconfort');
    }

    getStatus(): Observable<any[]> {
        return this.http.get<any[]>(this.api + 'api/referral/get-referral-status');
    }

    getReferralList(filter: ReferralFilterModel): Observable<ReferralDataModel[]> {
        return this.http.post<ReferralDataModel[]>(this.api + 'api/referral/get-referral-list', filter);
    }

    getReferralInformation(referralId: string): Observable<ReferralDataModel[]> {
        return this.http.get<ReferralDataModel[]>(this.api + `api/referral/get-referral-information/${referralId}`);
    }

    getTDOProviderDoctorReferredList(): Observable<DoctorDataModel[]> {
        return this.http.get<DoctorDataModel[]>(this.api + 'api/referral/gettdoproviderdoctorreferredlist');
    }


    getTDOReferringDoctors(): Observable<TDOReferringDataDoctorModel[]> {
        return this.http.get<TDOReferringDataDoctorModel[]>(this.api + 'api/referral/get-tdo-referring-doctors');
    }

    removeReferral(RefID: string): Observable<any> {
    // console.log(this.api + `api/referral/remove-referral/${RefID}`);
        return this.http.get<any>(this.api + `api/referral/remove-referral/${RefID}`);
    }

    deleteReferralSchedule(RefID: string): Observable<any> {
        return this.http.get<any>(this.api + `api/referral/deleteReferralSchedule/${RefID}`);
    }

    deleteReferralTreatment(RefID: string): Observable<any> {
        return this.http.get<any>(this.api + `api/referral/deleteReferralTreatment/${RefID}`);
    }

    deleteReferralOtherService(RefID: string): Observable<any> {
        return this.http.get<any>(this.api + `api/referral/deleteReferralOtherService/${RefID}`);
    }

    copyFromSelectedDr(RefID: string, DestinationDr: string): Observable<any> {
        return this.http.get<any>(this.api + `api/referral/copyReferralInfroFromDoctor/${RefID}/${DestinationDr}`);
    }

    cancelReferral(RefID: string): Observable<any> {
    // console.log(this.api + `api/referral/remove-referral/${RefID}`);
        return this.http.get<any>(this.api + `api/referral/cancel-referral/${RefID}`);
    }

    getPatientByReferralData(referralData: PatientSearchModel): Observable<any> {
        return this.http.post<PatientSearchModel[]>(this.api + 'api/patient/advanced-patient-search', referralData).pipe(catchError(this.handleError<any>('getPatient')));
    }

    getDoctorsByReferralEntityID(token: string, TdoGuid: string, ReferringDoctorQueryOptions: ReferringDoctorQueryOptionsModel = null): Observable<any[]> {
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token);
        const bodyPost = {
            ReferringDoctorQueryOptions,
            TdoGuid
        };
        return this.http.post<any[]>('/api/referral-Portal', bodyPost, {headers})
            .pipe(catchError(this.handleError<any>('getDoctorsByReferralEntityID')));
    }

    saveDataReferralDoctor(ReferralDoctor: DataReferralDoctorsModel): Observable<DataReferralDoctorsModel> {
        return this.http.post<DataReferralDoctorsModel[]>('/api/referral/saveDataReferralDoctor', ReferralDoctor)
            .pipe(catchError(this.handleError<any>('saveDataReferralDoctor')));
    }

    saveDataReferralFrontDesk(ReferralData: ReferralDataModel): Observable<ReferralDataModel> {
        return this.http.post<ReferralDataModel>('/api/referral/saveDataReferralFrontDesk', ReferralData)
            .pipe(catchError(this.handleError<any>('saveDataReferralFrontDesk')));
    }


    getReferralDoctorForMatch(referringData: any): Observable<DoctorDataModel> {
        return this.http.post<DoctorDataModel>(this.api + 'api/referral/doctor/', referringData).pipe(catchError(this.handleError<any>('matchReferral')));
    }

    getInsuranceForPatient(patientID: string): Observable<any> {
        // console.log('si');
        return this.http.get<any>(this.api + `api/insurance/getDataPatientActive/${patientID}`);
    }

    getReferralEntityByTDOCID(tdocid: string): Observable<ReferralEntityModel[]> {
    // const url: string;
        const method: string = 'referral/getReferralEntityByTDOCID/' + tdocid;
        const url = environment.TDOurl + method;
        return this.http.get<ReferralEntityModel[]>(url);
    }


    validateReferralPortalToken(token: string): Observable<any> {
        const method: string = 'referral-portal-site/validateToken';
        const url = environment.TDOurl + method;
        // Set the Authorization header with the token
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token);
        // Make the HTTP request with the headers
        return this.http.get<ReferralPortalAuthenticateResponseModel>(url, {headers});
    }
}
